import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public createNewEmployeeRequest(employee: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'employees/employees/createNewEmployeeRequest',
        { employee },
        { headers });
  }

  public parseCI(ci: any, fileExtension: string = 'jpg') {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'employees/employees/parseCI',
        { ci, fileExtension },
        { headers });
  }

  public extractCIInfo(filePath: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'employees/employees/extractCIInfo',
        { filePath },
        { headers });
  }

  public getEmployees() {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'employees/employees/getEmployees', {params});
  }
}
